import { actionCreator } from 'utils';
import * as CostTypes from '../types/costTypes';

// L O A D   C O S T S
export function loadCosts() {
    return {
        type: CostTypes.LOAD_COSTS,
    };
}

export function loadCostsRes(data) {
    return {
        type: actionCreator(CostTypes.LOAD_COSTS, 'res'),
        data,
    };
}

export function loadCostsErr() {
    return {
        type: actionCreator(CostTypes.LOAD_COSTS, 'err'),
    };
}
// L O A D   C O S T S


// S E T   C O S T   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T
export function setCostFilters(key, value) {
    return {
        type: CostTypes.SET_COST_FILTER,
        key,
        value,
    };
}

export function setCostFiltersRes(data) {
    return {
        type: actionCreator(CostTypes.SET_COST_FILTER, 'res'),
        data,
    };
}

export function setCostPagination(key, pagination) {
    return {
        type: CostTypes.SET_COST_PAGINATION,
        key,
        pagination,
    };
}

export function setCostSort(sort) {
    return {
        type: CostTypes.SET_COST_SORT,
        sort,
    };
}

export function resetCostFilters() {
    return {
        type: CostTypes.RESET_COST_FILTERS,
    };
}
// S E T   C O S T   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T


// A D D   C O S T
export function addCost(data) {
    return {
        type: CostTypes.ADD_COST,
        data,
    };
}

export function addCostRes(id) {
    return {
        type: actionCreator(CostTypes.ADD_COST, 'res'),
        id,
    };
}

export function addCostReq(id) {
    return {
        type: actionCreator(CostTypes.ADD_COST, 'req'),
        id,
    };
}

export function addCostErr(id) {
    return {
        type: actionCreator(CostTypes.ADD_COST, 'err'),
        id,
    };
}
// A D D   C O S T


// E D I T   C O S T
export function editCost(data) {
    return {
        type: CostTypes.EDIT_COST,
        data,
    };
}

export function editCostRes(id) {
    return {
        type: actionCreator(CostTypes.EDIT_COST, 'res'),
        id,
    };
}

export function editCostReq(id) {
    return {
        type: actionCreator(CostTypes.EDIT_COST, 'req'),
        id,
    };
}

export function editCostErr(id) {
    return {
        type: actionCreator(CostTypes.EDIT_COST, 'err'),
        id,
    };
}
// E D I T   C O S T


// S E T   C H E C K E D   C O S T   &   T O G G L E   C O S T   S T A T U S
export function setCheckedCost(ids) {
    return {
        type: CostTypes.SET_CHECKED_COST,
        ids,
    };
}

export function toggleCostStatus(ids, status) {
    return {
        type: CostTypes.TOGGLE_COST_STATUS,
        ids,
        status,
    };
}

export function toggleCostStatusRes() {
    return {
        type: actionCreator(CostTypes.TOGGLE_COST_STATUS, 'res'),
    };
}

export function toggleCostStatusErr() {
    return {
        type: actionCreator(CostTypes.TOGGLE_COST_STATUS, 'err'),
    };
}
// S E T   C H E C K E D   C O S T   &   T O G G L E   C O S T   S T A T U S
